export const getDOMBody = ({
  userDOM
}) => {
  const DOMBody = userDOM.querySelector('body');
  const DOMBodyContent = DOMBody ? DOMBody.innerHTML : null;
  return DOMBodyContent;
};